<template>
	<div class="app-container">
		<el-button type="primary" :loading="buttonloading" class="mt-3 mb-3 float-right" v-b-modal.addRow v-if="permissionList.includes(permission.add)" icon="el-icon-plus">{{$t('button.add')}}</el-button>
		<el-button type="warning" :loading="buttonloading" class="mt-3 mr-3 mb-3 float-right" v-if="permissionList.includes(permission.preview)" @click="getEditFooter()" icon="el-icon-edit">{{$t('menu.front_footer_edit')}}</el-button>
		<el-button type="success" :loading="buttonloading" class="mt-3 mr-2 mb-3 float-right" v-if="permissionList.includes(permission.preview)" @click="getPreviewRow()" icon="el-icon-view">{{$t('button.preview')}}</el-button>
		<el-table :data="tableData" v-loading="loading" style="width: 100%;" @expand-change="expandChange" @row-click="expandRow" class="mt-3" ref="tableTest" border fit highlight-current-row>
            <el-table-column v-for="title in ajaxTitles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                <template slot="header">
                    <p class="search-label">{{title.label}}</p>
                    <b-form-input :placeholder="title.label" @keyup.enter.native="initial" v-model="searchData[title.prop]" @change="saveData()"></b-form-input>
                </template>
            </el-table-column>
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <el-button type="primary" :loading="buttonloading" @click="getEditRow(scope.row.id)" v-if="permissionList.includes(permission.edit)" icon="el-icon-edit">{{$t('button.edit')}}</el-button>
                    <el-button type="danger" :loading="buttonloading" @click="deleteRow(scope.row.id)" v-if="permissionList.includes(permission.delete)" icon="el-icon-delete">{{$t('button.delete')}}</el-button>
                </template>
            </el-table-column>
        </el-table>

		<pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="pagination"/>
		
		<el-tooltip placement="top" :content="$t('general.back_to_top')">
			<backtotop :visibility-height="300" :back-position="50" transition-name="fade" />
		</el-tooltip>

        <b-modal id="addRow" :title="$t('menu.front_footer_add_layout')" @hide="clearDataList()" size="lg" hide-footer no-enforce-focus>
			<el-form >
                <b-row>
                    <b-col cols="12" md="6">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_code')}}</template>
                            <b-form-input v-model="dataList.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_content_type')}}</template>
                            <b-form-input v-model="dataList.content_type"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_title_color')}}</template>
                            <b-form-input v-model="dataList.title_color"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_sort')}}</template>
                            <el-input-number v-model="dataList.sort" :min="0" class="w-100" :precision="0"></el-input-number>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_is_title')}}</template>
                            <el-switch v-model="dataList.is_title" active-value="1" inactive-value="0"> </el-switch>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_status')}}</template>
                            <el-switch v-model="dataList.status" active-value="1" inactive-value="0"> </el-switch>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_title_style')}}</template>
                            <b-form-textarea rows="3" v-model="dataList.title_style"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                     <b-col cols="12" md="6">
                        <b-form-group label-cols="3" label-cols-lg="4">
                            <template slot="label">xs</template>
                            <b-form-input v-model="dataList.xs"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="3" label-cols-lg="4">
                            <template slot="label">sm</template>
                            <b-form-input v-model="dataList.sm"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="3" label-cols-lg="4">
                            <template slot="label">md</template>
                            <b-form-input v-model="dataList.md"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="3" label-cols-lg="4">
                            <template slot="label">lg</template>
                            <b-form-input v-model="dataList.lg"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="6" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_security')}}</template>
                            <b-form-input v-model="dataList.security" type="password" :placeholder="$t('msg.msg_security_password')"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

				<el-tabs class="mb-3">
					<el-tab-pane v-for="item in languageList" :key="item.code" :item="item" :label="item.name">
						<el-form-item :label="$t('admin_general.table_title')" class="mb-1">
							<b-form-input v-model="dataList.title[item.id]" :disabled="loading"></b-form-input>
						</el-form-item>
						
						<el-form-item :label="$t('admin_general.table_content')" class="mb-1">
							<br/>
							<Tinymce ref="editor" v-model="dataList.content[item.id]" :height="400" :disabled="loading" class="mt-3"/>
						</el-form-item>
					</el-tab-pane>
				</el-tabs>
			</el-form>

			<el-footer align="center" class="element-footer">
				<el-button size="medium" @click="$bvModal.hide('addRow')">{{$t('button.cancel')}}</el-button>
				<el-button size="medium" type="primary" @click="addRow()" :loading="buttonloading">{{$t('button.submit')}}</el-button>
			</el-footer>
        </b-modal>

		<b-modal id="editRow" :title="$t('menu.front_footer_layout_edit')" @hide="clearDataList()" size="lg" hide-footer no-enforce-focus>
			<el-form @submit.prevent="submit" >
                <b-row>
                    <b-col cols="12" md="6">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_code')}}</template>
                            <b-form-input v-model="dataList.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_content_type')}}</template>
                            <b-form-input v-model="dataList.content_type"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_title_color')}}</template>
                            <b-form-input v-model="dataList.title_color"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_sort')}}</template>
                            <el-input-number v-model="dataList.sort" :min="0" class="w-100" :precision="0"></el-input-number>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_is_title')}}</template>
                            <el-switch v-model="dataList.is_title" active-value="1" inactive-value="0"> </el-switch>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_status')}}</template>
                            <el-switch v-model="dataList.status" active-value="1" inactive-value="0"> </el-switch>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_title_style')}}</template>
                            <b-form-textarea rows="3" v-model="dataList.title_style"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                     <b-col cols="12" md="6">
                        <b-form-group label-cols="3" label-cols-lg="4">
                            <template slot="label">xs</template>
                            <b-form-input v-model="dataList.xs"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="3" label-cols-lg="4">
                            <template slot="label">sm</template>
                            <b-form-input v-model="dataList.sm"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="3" label-cols-lg="4">
                            <template slot="label">md</template>
                            <b-form-input v-model="dataList.md"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="3" label-cols-lg="4">
                            <template slot="label">lg</template>
                            <b-form-input v-model="dataList.lg"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="6" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_security')}}</template>
                            <b-form-input v-model="dataList.security" type="password" :placeholder="$t('msg.msg_security_password')"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

				<el-tabs class="mb-3">
					<el-tab-pane v-for="item in languageList" :key="item.code" :item="item" :label="item.name">
						<el-form-item :label="$t('admin_general.table_title')" class="mb-1">
							<b-form-input v-model="dataList.title[item.id]" :disabled="loading"></b-form-input>
						</el-form-item>
						
						<el-form-item :label="$t('admin_general.table_content')" class="mb-1">
							<br/>
							<Tinymce ref="editor" v-model="dataList.content[item.id]" :height="400" :disabled="loading" class="mt-3"/>
						</el-form-item>
					</el-tab-pane>
				</el-tabs>
			</el-form>

			<el-footer align="center" class="element-footer">
				<el-button size="medium" @click="$bvModal.hide('editRow')">{{$t('button.cancel')}}</el-button>
				<el-button size="medium" type="primary" @click="editRow()" :loading="buttonloading">{{$t('button.submit')}}</el-button>
			</el-footer>
        </b-modal>

        <b-modal id="editFooterRow" :title="$t('menu.front_footer_edit')" @hide="clearDataList()" size="lg" hide-footer no-enforce-focus>
			<el-form id="addForm" @submit.prevent="submit" enctype="multipart/form-data">
				<b-row>
					<b-col cols="12" md="6">
						<b-form-group label-cols="12" label-cols-lg="4">
							<template slot="label">{{$t('admin_general.table_background_type')}}</template>
							<b-form-input v-model="footerDetail.background_type"></b-form-input>
						</b-form-group>
						<b-form-group label-cols="12" label-cols-lg="4">
							<template slot="label">{{$t('admin_general.table_background_color')}}</template>
							<b-form-input v-model="footerDetail.background_color"></b-form-input>
						</b-form-group>
						<b-form-group label-cols="12" label-cols-lg="4">
							<template slot="label">{{$t('admin_general.table_top_bar_type')}}</template>
							<b-form-input v-model="footerDetail.top_bar_type"></b-form-input>
						</b-form-group>
						<b-form-group label-cols="12" label-cols-lg="4">
							<template slot="label">{{$t('admin_general.table_top_bar_color')}}</template>
							<b-form-input v-model="footerDetail.top_bar_color"></b-form-input>
						</b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_show_nav')}}</template>
                            <el-switch v-model="footerDetail.show_nav" active-value="1" inactive-value="0"> </el-switch>
                        </b-form-group>
						<b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin_general.table_style')}}</template>
                            <b-form-textarea rows="3" v-model="footerDetail.style"></b-form-textarea>
                        </b-form-group>
					</b-col>
					
					<b-col cols="12" md="6">
						<b-form-group label-cols="12" label-cols-lg="4">
							<template slot="label">{{$t('admin_general.table_security')}}</template>
							<b-form-input v-model="footerDetail.security" type="password" :placeholder="$t('msg.msg_security_password')"></b-form-input>
						</b-form-group>
						<b-form-group label-cols="12" label-cols-lg="4">
							<template slot="label">{{$t('admin_general.table_background_image')}}</template>
							<el-popover placement="right" width="130" trigger="click" class="img-thumbnail" v-model="popover">
								<el-button type="primary" icon="el-icon-edit" @click="openImage();"></el-button>
								<el-button type="danger" icon="el-icon-delete" @click="initialImage();"></el-button>
								
								<el-image style="width: 100px; height: 100px" fit="fill" :src="footerDetail.background_image" slot="reference"></el-image>
							</el-popover>
						</b-form-group>
					</b-col>
				</b-row>
			</el-form>

			<el-footer align="center" class="element-footer">
				<el-button size="medium" @click="$bvModal.hide('editFooterRow')">{{$t('button.cancel')}}</el-button>
				<el-button size="medium" type="primary" @click="editFooter()" :loading="buttonloading">{{$t('button.submit')}}</el-button>
			</el-footer>
        </b-modal>

		<b-modal id="previewRow" :title="$t('menu.front_footer_preview')" size="lg" >
			<el-tabs class="mb-3">
				<el-tab-pane style="min-height:200px;" v-for="language in languageList" :key="language.id" :label="language.name">
					<b-row v-bind:style="footerSetting.style" >
						<b-col v-for="footer in footerList" :key="footer.id"  v-html="footer.content[language.id]" v-bind:style="footer.title_style" :class="footer.class">
						</b-col>
					</b-row>
					<b-navbar toggleable="lg" type="dark" v-bind:style="footerDetail.style">
						
					</b-navbar>
				</el-tab-pane>
			</el-tabs>
        </b-modal>

		<imagemanager ref="imagemanager" :isShowDialog="openImageDialog" @dialogData="closeImageDialog" @getData="getImageDialog"/>
	</div>

</template>

<script>
import {getLocalStorage} from '@/system/store/localstorage';
import {postMethod} from '@/system/model/post/post';
import {getDAES, getEAES} from '@/system/library/security';
import pagination from '@/components/pagination';
import backtotop from '@/components/backtotop';
import Tinymce from '@/components/tinymce';
import imagemanager from '@/views/image';

let searchForm = {
	pagination: 1,
	limit: 10,
	id: '',
	created_at:'',
	code:'',
	content_type:'',
	is_title:'',
}
			
export default{
	components: { pagination, backtotop, Tinymce, imagemanager },
	inject:['preloader'],
	data(){
		return {
			loading: true,
			buttonloading: false,
			tableData: [],
			total: 0,
			errors: [],
			submitForm: {
				id:'',
				security:'',
			},
			postData: {
				data: '',
				language: '',
			},
			searchData:Object.assign({}, searchForm),
			listQuery: {
				page: 1,
				limit: 10
			},
			ajaxTitles:[{
                prop: "id",
                label: this.$t('admin_general.table_id'),
                width:'50'
            },{
                prop: "code",
                label: this.$t('admin_general.table_code'),
                width:'100'
			},{
                prop: "content_type",
                label: this.$t('admin_general.table_content_type'),
                width:'100'
			},{
                prop: "sort",
                label: this.$t('admin_general.table_sort'),
                width:'100'
			},{
                prop: "is_title",
                label: this.$t('admin_general.table_is_title'),
                width:'100'
			}],
			footerDetail: [],
			footerList: [],
			popover:false,
			dataList:{
				category:'',
				code:'',
				security:'',
				title:[],
				content:[]
			},
			permission:{
                ajaxTable:'4F4A4L',
                add:'1FRISB',
                DBadd:'HG96WH',
                edit:'AJR1AR',
                preview:'AJR1AR',
                DBedit:'GMBFV2',
                delete:'HS6W2Y',
                DBdelete:'NWBRHV'
            },
			permissionList:[],
			languageList:[],
			footerSetting:[],
			defaultImage: '',
			openImageDialog: false,
		}
	}, methods: {
		initial(){
			if(this.permissionList.includes(this.permission.ajaxTable)){
				this.loading = true;
				this.buttonloading = true;
				this.postData.data = '';
				this.postData.data = getEAES(JSON.stringify(this.searchData));
				var self = this;
				var result = postMethod('front/footer/ajaxTable',this.postData);
				result.then(function(value){
					var data = JSON.parse(getDAES(value.data));

					if(value.valid){
						self.tableData = data.datatable.data;
						self.total = parseInt(data.datatable.total_number);
						self.listQuery.page = parseInt(data.datatable.current_pagination);
						self.listQuery.limit = parseInt(data.datatable.limit);
						self.buttonloading = false;
						self.loading = false;
					}
				});
			}
		},clearDataList(){
			this.dataList.code = '';
			this.dataList.content_type = '';
			this.dataList.is_title = '';
			this.dataList.title_style = '';
			this.dataList.title_color = '';
			this.dataList.xs = '';
			this.dataList.sm = '';
			this.dataList.md = '';
			this.dataList.lg = '';
			this.dataList.sort = 10;
			this.dataList.security = '';
			this.dataList.title = [];
			this.dataList.content = [];
		},addRow(){
			if(this.permissionList.includes(this.permission.DBadd)){
				this.preloader(true);
				this.buttonloading = true;
				this.postData.data = '';
				this.postData.data = getEAES(JSON.stringify(this.dataList));
				var text = '';
				var result = postMethod('front/footer/DBadd',this.postData);

				result.then((value) =>{
					var data = JSON.parse(getDAES(value.data));

					if(value.valid){
						this.$message({
							message: data.returnMsg,
							type: 'success'
						});
						
						this.$bvModal.hide('addRow');
						this.initial();
					}else{					
						data.returnMsg.forEach(function (value){
							text+= value+"<br/>";
						});
						
						this.$method.popupErrorMessage(this,text);
					}
					this.buttonloading = false;
					this.preloader(false);
				});
			}
		},getEditRow(id){
			if(this.permissionList.includes(this.permission.edit)){
				this.buttonloading = true;
				this.submitForm.id = id;
				this.postData.data = '';
				this.postData.data = getEAES(JSON.stringify(this.submitForm));
				var result = postMethod('front/footer/edit',this.postData);
				result.then((value) =>{
					var data = JSON.parse(getDAES(value.data));

					if(value.valid){
						this.dataList = data.thisDetail;
						var content = [];
						content = JSON.stringify(this.dataList.content);
						content = this.decoder(content);
						this.dataList.content = JSON.parse(content);
						this.$bvModal.show('editRow');
					}
					this.buttonloading = false;
				});
			}
		},editRow(){
			if(this.permissionList.includes(this.permission.DBedit)){
				this.buttonloading = true;
				this.preloader(true);
				this.postData.data = '';
				this.postData.data = getEAES(JSON.stringify(this.dataList));
				var text = '';
				var result = postMethod('front/footer/DBedit',this.postData);

				result.then((value) =>{
					var data = JSON.parse(getDAES(value.data));

					if(value.valid){
						this.$message({
							message: data.returnMsg,
							type: 'success'
						});
						
						this.$bvModal.hide('editRow');
						this.initial();
					}else{					
						data.returnMsg.forEach(function (value){
							text+= value+"<br/>";
						});
						
						this.$method.popupErrorMessage(this,text);
					}
					
					this.buttonloading = false;
					this.preloader(false);
				});
			}
		},deleteRow(id){
			if(this.permissionList.includes(this.permission.DBdelete)){
				this.buttonloading = true;
				var text = '';
				this.$prompt(this.$t('msg.msg_delete'), this.$t('msg.prompt'), {
					confirmButtonText: this.$t('button.confirm'),
					cancelButtonText: this.$t('button.cancel'),
					inputPlaceholder: this.$t('msg.msg_security_password'),
					inputType: 'password'
				}).then(({ value }) => {
					this.submitForm.id = id;
					this.submitForm.security = value;
					this.postData.data = '';
					this.postData.data = getEAES(JSON.stringify(this.submitForm));
					var result = postMethod('front/footer/DBdelete',this.postData);
					result.then((value) =>{
						var data = JSON.parse(getDAES(value.data));
						if(value.valid){
							this.$message({
							type: 'success',
							message: data.returnMsg
							});
							
							this.initial();
							this.buttonloading = false;
						}else{
							this.errors = data.returnMsg;
							
							this.errors.forEach(function (value){
							text+= value+"<br/>";
							});
							
							this.$method.popupErrorMessage(this, text);
							this.buttonloading = false;
						}
					
					});

				}).catch(() => {
					this.buttonloading = false;          
				});
			}
		},getEditFooter(){
			if(this.permissionList.includes(this.permission.edit)){
				this.footerDetail = [];
				this.buttonloading = true;
				this.submitForm.code = 'footer';
				this.postData.data = '';
				this.postData.data = getEAES(JSON.stringify(this.submitForm));
				var result = postMethod('front/footer/info',this.postData);
				result.then((value) =>{
					var data = JSON.parse(getDAES(value.data));

					if(value.valid){
						this.footerDetail = data.thisDetail;
						this.$bvModal.show('editFooterRow');
					}
					this.buttonloading = false;
				});
			}
		},editFooter(){
			if(this.permissionList.includes(this.permission.DBedit)){
				this.buttonloading = true;
				this.preloader(true);
				this.postData.data = '';
				this.postData.data = getEAES(JSON.stringify(this.footerDetail));
				var text = '';
				var result = postMethod('front/footer/DBfooter',this.postData);

				result.then((value) =>{
					var data = JSON.parse(getDAES(value.data));

					if(value.valid){
						this.$message({
							message: data.returnMsg,
							type: 'success'
						});
						
						this.$bvModal.hide('editFooterRow');
						this.initial();
					}else{					
						data.returnMsg.forEach(function (value){
							text+= value+"<br/>";
						});
						
						this.$method.popupErrorMessage(this,text);
					}
					
					this.buttonloading = false;
					this.preloader(false);
				});
			}
		},getPreviewRow(){
			if(this.permissionList.includes(this.permission.edit)){
				this.footerDetail = [];
				this.buttonloading = true;
				this.submitForm.id = 1;
				this.postData.data = '';
				this.postData.data = getEAES(JSON.stringify(this.submitForm));
				var result = postMethod('front/footer/preview',this.postData);
				result.then((value) =>{
					var data = JSON.parse(getDAES(value.data));

					if(value.valid){
						this.footerList = data.footerList;
						this.footerSetting = data.footerSetting;
						this.$bvModal.show('previewRow');
					}
					this.buttonloading = false;
				});
			}
		},pagination(){
			this.searchData.pagination = this.listQuery.page;
			this.searchData.limit = this.listQuery.limit;
			this.initial();
		},expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                this.$refs.tableTest.toggleRowExpansion(expandedRows[0]);
            }
        },initialImage(){
			this.footerDetail.background_image = this.defaultImage;
			this.popover = false;
		},closeImageDialog(data) {
			this.openImageDialog = data;
		},openImage(){
			this.openImageDialog = true;
			this.$refs.imagemanager.onOpen(0); 
			this.popover = false;
		},getImageDialog(data){
			this.footerDetail.background_image = data.path;
			this.openImageDialog = false;
		},decoder (str) {
			str = str.replace(/&quot;/g,"'");
			var textArea = document.createElement('textarea');
			textArea.innerHTML = str;

			return textArea.value;
		},saveData(){
			searchForm = this.searchData;
		}
	}, created: function(){
		var currentLang = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'en';
		this.postData.language = currentLang;
		this.permissionList = JSON.parse(getLocalStorage('permissionList'));
		this.languageList = JSON.parse(getLocalStorage('languageList'));
		this.initial();
	}
}
</script>